import {
	constant
} from '../../config.js'
import commonUtils from '../common-utlis.js'
import requestUtil from '../request-utils.js'
import {
	getTimelinesData,
	setTimelinesData
} from './data-refresh.js'
import {
	getParam
} from './api-params.js'
import {
	getChannelInfo
} from './api-channel.js'
import {
	callFeignV1
} from './api-callFeign.js';

/**
 * 获取用户信息
 * @param {*} loginParams 登录参数结构{loginName,loginPwd}或{tel,verificationCode}
 * @param {*} isRefresh 
 */
const getCustomerInfo = async (loginParams = {}, isRefresh = false) => {
	try {
		let customerInfo = getTimelinesData(constant.DATA_KEY_CUSTOMER, false) || {};

		// 如果需要获取最新数据或缓存中没有数据，则不读取缓存
		if (!isRefresh && !commonUtils.isNullOrEmpty(customerInfo)) {
			return customerInfo;
		}

		// 调用接口获取客户信息
		customerInfo = await _loginAndGetCustomerInfo(loginParams);

		// 没有查询到相关客户信息或会员限制检测不通过则直接返回
		if (!customerInfo || !customerInfo.customerId || await _loginLimitCheck(customerInfo)) {
			localStorage.removeItem("pc_lastLoginDistributorId");
			return {
				error: customerInfo.error || '',
				errorTip: customerInfo.errorTip || '',
			};
		}

		// 补充会员有效期并缓存数据
		_setCustomerInfo(customerInfo);

		// 返回用户信息
		return customerInfo;
	} catch (e) {
		// 检测不通过提示异常情况
		console.log("用户信息获取失败：" + e.message);
		return {};
	}
}

/**
 * 检测返回数据
 */
const _setCustomerInfo = async (customerInfo) => {
	// 处理会员有效期
	_setVipLevelValidityDateInfo(customerInfo);

	// 缓存数据
	setTimelinesData(constant.DATA_KEY_CUSTOMER, customerInfo);
	localStorage.setItem("pc_customerId", customerInfo.customerId);
	localStorage.setItem("pc_nickname", customerInfo.nickname);
	localStorage.setItem("pc_lastLoginDistributorId", customerInfo.distributorId);
}

/**
 * 获取用户信息
 */
const _loginAndGetCustomerInfo = (loginParams) => {
	// 补充参数customerId
	if (localStorage.getItem("pc_lastLoginDistributorId")) {
		loginParams.distributorId = localStorage.getItem("pc_lastLoginDistributorId");
	}

	// 不是登录调用且没有登录过时，直接返回
	if (commonUtils.isNullOrEmpty(loginParams)) {
		return {}
	}

	// 补充参数loginFromWx
	loginParams.loginFromWx = false;

	return new Promise((resolve, reject) => {
		requestUtil.jackyunPost({
			method: "jmall.customer.login",
			jsonStr: JSON.stringify(loginParams)
		}, function(res) {
			if (res && (res.code != 200 || !res.result.data)) {
				resolve({
					error: res.msg
				});
			} else {
				resolve(res.result.data);
			}
		});
	})
}

/**
 * 更新账号密码
 */
const updateCustomerNameAndPwd = (reqData) => {
	return new Promise((resolve, reject) => {
		requestUtil.jackyunPost({
			method: "jmall.customer.updatenameandpwd",
			jsonStr: JSON.stringify(reqData)
		}, function(res) {
			if (res && (res.code != 200 || !res.result.data)) {
				resolve(res.msg)
			} else {
				resolve(res.result.data);
			}
		});
	})
}

/**
 * 注册
 */
const registeCustomer = async (tel, restrictLogin) => {
	try {
		// 调用接口获取客户信息
		let customerInfo = await _registeCustomerOrigion(tel, restrictLogin);

		// 没有查询到相关客户信息或会员限制检测不通过则直接返回
		if (!customerInfo || !customerInfo.customerId || await _loginLimitCheck(customerInfo)) {
			return {
				error: customerInfo.error || '',
				errorTip: customerInfo.errorTip || '',
				phoneOfInLimit: customerInfo.phone || ''
			};
		}

		// 补充会员有效期并缓存数据
		_setCustomerInfo(customerInfo);

		// 返回用户信息
		return customerInfo;


	} catch (e) {
		console.log("用户注册失败：" + e.message);
		return {};
	}
}

/**
 * 注册
 */
const _registeCustomerOrigion = async (tel, restrictLogin) => {
	// 判断手机号是否存在
	if (!tel) {
		return {
			error: '手机号缺失'
		}
	}

	let channelInfo = await getChannelInfo(localStorage.getItem("pc_channelId"));
	let channelName = channelInfo.channelName;
	let channelId = channelInfo.channelId;
	let channelIdRangeList = await _getOnShelfChannelIds();
	let upperId = 0;
	return new Promise((resolve, reject) => {
		requestUtil.jackyunPost({
			method: "jmall.customer.register",
			jsonStr: JSON.stringify({
				tel,
				channelName,
				channelId,
				channelIdRangeList,
				upperId,
				customerFrom: "pc商城",
				restrictLogin
			})
		}, function(res) {
			if (res && (res.code != 200 || !res.result.data)) {
				resolve({
					error: res.msg
				})
			} else {
				resolve(res.result.data);
			}
		});
	})
}

/**
 * 获取上线渠道Id集合
 */
const _getOnShelfChannelIds = async () => {
	// 获取所需参数
	let paramList = await getParam("bindSaleChannelId,bindSaleChannelName,isOpenStore,multipleChannelInfo");

	// 获取上线渠道Id集合
	let onShelfChannelIds = [];
	// 未开启则返回默认渠道
	if (paramList.isOpenStore == "1") {
		try {
			// 吉商城设置的多门店信息
			let multipleChannelList = JSON.parse(paramList.multipleChannelInfo);
			// 从上线渠道中获取出建档渠道，如果不存在则使用默认渠道
			onShelfChannelIds = multipleChannelList.filter(t => t.on == "1").map(t => t.cId);
		} catch (e) {}
	}

	// 将所有数据合并
	onShelfChannelIds = [paramList.bindSaleChannelId, ...onShelfChannelIds];
	// 数据去重
	onShelfChannelIds = [...new Set(onShelfChannelIds)]

	return onShelfChannelIds;
}

/**
 * 设置用户有效期信息
 */
const _setVipLevelValidityDateInfo = async (customerInfo) => {
	try {
		// 无效用户不处理
		if (!customerInfo.customerId || !customerInfo.phone) {
			return;
		}

		// 有效期不存在或者2999年+的设置永久有效
		if (!customerInfo.vipLevelExpireTime || customerInfo.vipLevelExpireTime.startsWith("2999")) {
			customerInfo.vipLevelValidityDateInfo = "永久有效";
		} else {
			// xxxx年xx月xx日到期
			customerInfo.vipLevelValidityDateInfo = commonUtils.stringToDate(customerInfo.vipLevelExpireTime, false, true) + "到期";
		}
	} catch (e) {
		customerInfo.vipLevelValidityDateInfo = "永久有效";
	}
}

/**
 * 用户登录限制检测
 */
const _loginLimitCheck = async (customerInfo) => {
	// 检测黑名单
	if (customerInfo.blackCustomer == 1) {
		customerInfo.error = "黑名单用户";
		customerInfo.errorTip = "您的账户存在异常状态，请联系商家处理";
		return true;
	}

	// 处理异常会员等级情况，方式空数据影响判断结果
	let memberGradeId = customerInfo.vipLevel == '0' || !customerInfo.vipLevel ? '*****' : customerInfo.vipLevel;

	// 检测会员等级限制
	let paramList = await getParam("isOpenLoginLimit,loginForMemberGradeId,pc_restrictLoginText,loginLimitType");

	// 是否限制会员等级登录注册
	let isOpenLoginLimit = paramList.isOpenLoginLimit;

	// 限制登录的会员等级
	let loginForMemberGradeId = paramList.loginForMemberGradeId;

	// 限制登录提示文本
	let remainText = paramList.pc_restrictLoginText

	// 限制登录注册（吉客云无该用户或者会员等级不可登录）
	if (isOpenLoginLimit == '1' && !!loginForMemberGradeId && loginForMemberGradeId != "all" && (loginForMemberGradeId.indexOf(memberGradeId) < 0)) {
		// 会员等级不符合 可以重新申请
		let isNeedRegister = ['auditLimitOfPrice', 'auditLimitOfCheckIn'].includes(paramList.loginLimitType);

		customerInfo.error = isNeedRegister ? '需要申请' : (remainText || "会员等级限制不满足");
		return true;
	}
	return false;
}

/**
 * 获取 注册申请状态
 */
const getRegisterApplyDetail = async (tel) => {
	return new Promise((resolve, reject) => {
		requestUtil.jackyunPost({
			method: "jmall.customer.getcustomerapplydetail",
			jsonStr: JSON.stringify({
				contactTel: tel,
			})
		}, function(res) {
			let data = {};
			if (res && res.code == 200) {
				data = res.result.data || {};

				// 过滤审核完成的数据 pc因为没有默认登录逻辑不能直接过滤
				// data = data.auditStatus == 1 ? {} : data;

				// 驳回原因
				data.rejectReason = data.auditBak || "";
			}
			resolve(data)
		});
	})
}

/**
 * 提交申请
 */
const addRegisterApply = async (registerParamObj) => {
	let channelInfo = await getChannelInfo(localStorage.getItem("pc_channelId"));
	let channelName = channelInfo.channelName;
	let channelId = channelInfo.channelId;
	let channelIdRangeList = await _getOnShelfChannelIds();

	// 主商城 accountname
	let memname = localStorage.getItem("JackyunUserName");

	let subMemberName = localStorage.getItem("SubMemberName");
	let subJmallName = localStorage.getItem("SubJmallName");

	return new Promise((resolve, reject) => {
		requestUtil.jackyunPost({
			method: "jmall.customer.addcustomerapply",
			jsonStr: JSON.stringify({
				...registerParamObj,
				channelId: registerParamObj.channelId || channelId,
				channelName: registerParamObj.channelName || channelName,
				channelIdRangeList,
				customerFrom: "pc商城",
				subMemName: subMemberName || memname,
				subShopName: subJmallName,
				upperId: 0,
			})
		}, function(res) {
			if (res && res.code == '200') {
				resolve();
			} else {
				resolve(res.msg);
			}
		});
	})
}

/**
 * 获取 注册申请状态 测试
 */
const auditCustomerApply = async (applyId, auditStatus) => {
	return new Promise((resolve, reject) => {
		requestUtil.jackyunPost({
			method: "jmall.customer.auditcustomerapply",
			jsonStr: JSON.stringify({
				applyId,
				auditStatus,
				operatorName: 'aaa'
			})
		}, function(res) {
			if (res && res.code == '200') {
				resolve();
			} else {
				resolve(res.msg);
			}
		});
	})
}

/**
 * 获取用户Id
 */
const getCustomerId = () => {
	return localStorage.getItem("pc_customerId") || "";
}


/**
 * 获取注册申请表单 业务员 下拉选项
 */
const getOptionListOfSeller = () => {
	// 缓存存在 直接返回
	let userlistOfPullOption = JSON.parse(localStorage.getItem('userlistOfPullOption') || '[]')
	if (userlistOfPullOption && userlistOfPullOption.length > 0) {
		return userlistOfPullOption
	}
	return new Promise((resolve, reject) => {
		callFeignV1("erp.saleschannelinfo.userlist", {
			jsonStr: JSON.stringify({
				channelId: localStorage.getItem("pc_channelId")
			})
		}).then((res) => {
			let data = [];
			if (res && res.code == 200) {
				data = res.result.data || [];
			}
			localStorage.setItem('userlistOfPullOption', JSON.stringify(data))
			resolve(data);
		});
	})
}

/**
 * 获取注册申请表单 建档渠道 下拉选项
 */
const getOptionListOfChannel = async () => {
	let channelInfo = await getChannelInfo(localStorage.getItem("pc_channelId"));
	let channelId = channelInfo.channelId;
	let companyId = channelInfo.companyId;

	// 缓存存在 直接返回
	let channelInfoOfPullOption = JSON.parse(localStorage.getItem('channelInfoOfPullOption') || '[]')
	if (channelInfoOfPullOption && channelInfoOfPullOption.length > 0) {
		return channelInfoOfPullOption
	}

	return new Promise((resolve, reject) => {
		callFeignV1("erp.saleschannelinfo.saleschannelinfopull", {
			jsonStr: JSON.stringify({
				includeOwnerVirtualStore: 0,
				channelType: "0,1,2,3,6",
				channelId: channelId,
				companyIds: companyId,
			})
		}).then((res) => {
			let data = [];
			if (res && res.code == 200) {
				data = res.result.data || [];
			}
			localStorage.setItem('channelInfoOfPullOption', JSON.stringify(data))
			resolve(data);
		});
	})
}

/**
 * 获取会员收款账户
 */
const getCustomerBankListFromCrm = () => {
	let customerId = getCustomerId()
	return new Promise((resolve, reject) => {
		callFeignV1("crm.account.list", {
			jsonStr: JSON.stringify({
				jsonStr: {
					customerId
				},
				pageIndex: 0,
				pageSize: 1000,
			})
		}).then((res) => {
			let data = [];
			if (res && res.code == 200) {
				data = res.result.data || [];
			}
			resolve(data);
		});
	})
}

/**
 * 修改会员收款账户
 */
const editCustomerBankInfo = (reqData) => {
	let customerId = getCustomerId()
	return new Promise((resolve, reject) => {
		callFeignV1("crm.account.edit", {
			jsonStr: JSON.stringify({
				jsonStr: {
					customerId,
					...reqData
				}
			})
		}).then((res) => {
			let data = {};
			if (res && res.code == 200) {
				data = res.result.data || {};
			}
			resolve(data);
		});
	})
}

/**
 * 删除会员收款账户
 */
const deleteCustomerBankInfo = (reqData) => {
	let customerId = getCustomerId()
	return new Promise((resolve, reject) => {
		callFeignV1("crm.account.delete", {
			jsonStr: JSON.stringify({
				jsonStr: [reqData.id]
			})
		}).then((res) => {
			if (!res || res.code != 200) {
				console.log(res.msg)
			}
			resolve(res && res.code == 200);
		});
	})
}

/**
 * 新增会员收款账户
 */
const addCustomerBankInfo = (reqData) => {
	let customerId = getCustomerId()
	return new Promise((resolve, reject) => {
		callFeignV1("crm.account.add", {
			jsonStr:JSON.stringify( {
				jsonStr:{
					customerId,
					...reqData
				}
			})
		}).then((res) => {
			let data = {};
			if (res && res.code == 200) {
				data = res.result.data || {};
			}
			resolve(data);
		});
	})
}

export {
	getCustomerInfo,
	updateCustomerNameAndPwd,
	registeCustomer,
	getOptionListOfSeller,
	getOptionListOfChannel,
	addRegisterApply,
	getRegisterApplyDetail,
	getCustomerId,
	auditCustomerApply,
	getCustomerBankListFromCrm,
	editCustomerBankInfo,
	deleteCustomerBankInfo,
	addCustomerBankInfo
}